import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.png';

import SpeciaLogo2 from '../../resources/circle specia 2.png';
import { useAuth } from 'react-oidc-context';
import { Button } from '@mui/material';

import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

export default function EmployeeSetup() {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh' }}>
      <div style={{ display: 'flex', flexDirection: 'row', padding: '5vh 15vw', alignItems: 'center', height: '100vh' }}>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '1vw 10vw 5vw 10vw', color: 'rgb(0, 15, 30, 0.9)', backgroundColor: 'rgb(254, 254, 255, 0.8)', padding: '2vw 4vw', textAlign: 'center', borderRadius: '1.5vw' }}>
          <div style={{}}>
            <header style={{ marginBottom: '2vw' }}>
              <BusinessOutlinedIcon style={{ color: '#1c6c6c', marginBottom: '1.5vw', fontSize: '3vw' }} />

              <h1 style={{ fontSize: '1.5vw', marginBottom: '1vw' }}>Join your Organization</h1>
              <p style={{ fontSize: '0.85vw', margin: 0 }}>Please contact your administrator for access to your organization</p>
            </header>

            <Button
              onClick={() => { navigate(-1); }}
              variant="outlined"
              style={{
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                width: '20vw', marginTop: '1vw' }}
            >
              Previous
            </Button>

          </div>
        </div>

      </div>

    </div>
  );
}
